interface Dictionary { [index: string]: string; };

export const toHalfWidth = (str: string) => str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xFEE0));
export const toFullWidth = (str: string) => str.replace(/[A-Za-z0-9]/g, (s) => String.fromCharCode(s.charCodeAt(0) + 0xFEE0));
export const kanaToHira = (str: string) => str.replace(/[\u30a1-\u30f6]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0x60));
export const hiraToKana = (str: string) => str.replace(/[\u3041-\u3096]/g, (s) => String.fromCharCode(s.charCodeAt(0) + 0x60));

export const toDcfKana = (str: string) => {
  const kana = hiraToKana(str)
  const smallToLargeKanaMap: { [key: string]: string } = {
    'ァ': 'ア', 'ィ': 'イ', 'ゥ': 'ウ', 'ェ': 'エ', 'ォ': 'オ',
    'ッ': 'ツ', 'ャ': 'ヤ', 'ュ': 'ユ', 'ョ': 'ヨ',
    'ヮ': 'ワ', 'ヵ': 'カ', 'ヶ': 'ケ'
  };
  const regex = new RegExp(`[${Object.keys(smallToLargeKanaMap).join('')}]`, 'g')
  return kana.replace(regex, (s) => smallToLargeKanaMap[s])
}

export const kanaFullToHalf = (str: string) => {
  const kanaMap: Dictionary = {
    "ガ": "ｶﾞ", "ギ": "ｷﾞ", "グ": "ｸﾞ", "ゲ": "ｹﾞ", "ゴ": "ｺﾞ",
    "ザ": "ｻﾞ", "ジ": "ｼﾞ", "ズ": "ｽﾞ", "ゼ": "ｾﾞ", "ゾ": "ｿﾞ",
    "ダ": "ﾀﾞ", "ヂ": "ﾁﾞ", "ヅ": "ﾂﾞ", "デ": "ﾃﾞ", "ド": "ﾄﾞ",
    "バ": "ﾊﾞ", "ビ": "ﾋﾞ", "ブ": "ﾌﾞ", "ベ": "ﾍﾞ", "ボ": "ﾎﾞ",
    "パ": "ﾊﾟ", "ピ": "ﾋﾟ", "プ": "ﾌﾟ", "ペ": "ﾍﾟ", "ポ": "ﾎﾟ",
    "ヴ": "ｳﾞ", "ヷ": "ﾜﾞ", "ヺ": "ｦﾞ",
    "ア": "ｱ", "イ": "ｲ", "ウ": "ｳ", "エ": "ｴ", "オ": "ｵ",
    "カ": "ｶ", "キ": "ｷ", "ク": "ｸ", "ケ": "ｹ", "コ": "ｺ",
    "サ": "ｻ", "シ": "ｼ", "ス": "ｽ", "セ": "ｾ", "ソ": "ｿ",
    "タ": "ﾀ", "チ": "ﾁ", "ツ": "ﾂ", "テ": "ﾃ", "ト": "ﾄ",
    "ナ": "ﾅ", "ニ": "ﾆ", "ヌ": "ﾇ", "ネ": "ﾈ", "ノ": "ﾉ",
    "ハ": "ﾊ", "ヒ": "ﾋ", "フ": "ﾌ", "ヘ": "ﾍ", "ホ": "ﾎ",
    "マ": "ﾏ", "ミ": "ﾐ", "ム": "ﾑ", "メ": "ﾒ", "モ": "ﾓ",
    "ヤ": "ﾔ", "ユ": "ﾕ", "ヨ": "ﾖ",
    "ラ": "ﾗ", "リ": "ﾘ", "ル": "ﾙ", "レ": "ﾚ", "ロ": "ﾛ",
    "ワ": "ﾜ", "ヲ": "ｦ", "ン": "ﾝ",
    "ァ": "ｧ", "ィ": "ｨ", "ゥ": "ｩ", "ェ": "ｪ", "ォ": "ｫ",
    "ッ": "ｯ", "ャ": "ｬ", "ュ": "ｭ", "ョ": "ｮ",
    "。": "｡", "、": "､", "ー": "ｰ", "「": "｢", "」": "｣", "・": "･",
    "　": " "
  };
  const reg = new RegExp('(' + Object.keys(kanaMap).join('|') + ')', 'g');
  return str.replace(reg, (s) => kanaMap[s]).replace(/゛/g, 'ﾞ').replace(/゜/g, 'ﾟ');
}
export const kanaHalfToFull = (str: string) => {
  const kanaMap: Dictionary = {
    'ｶﾞ': 'ガ', 'ｷﾞ': 'ギ', 'ｸﾞ': 'グ', 'ｹﾞ': 'ゲ', 'ｺﾞ': 'ゴ',
    'ｻﾞ': 'ザ', 'ｼﾞ': 'ジ', 'ｽﾞ': 'ズ', 'ｾﾞ': 'ゼ', 'ｿﾞ': 'ゾ',
    'ﾀﾞ': 'ダ', 'ﾁﾞ': 'ヂ', 'ﾂﾞ': 'ヅ', 'ﾃﾞ': 'デ', 'ﾄﾞ': 'ド',
    'ﾊﾞ': 'バ', 'ﾋﾞ': 'ビ', 'ﾌﾞ': 'ブ', 'ﾍﾞ': 'ベ', 'ﾎﾞ': 'ボ',
    'ﾊﾟ': 'パ', 'ﾋﾟ': 'ピ', 'ﾌﾟ': 'プ', 'ﾍﾟ': 'ペ', 'ﾎﾟ': 'ポ',
    'ｳﾞ': 'ヴ', 'ﾜﾞ': 'ヷ', 'ｦﾞ': 'ヺ',
    'ｱ': 'ア', 'ｲ': 'イ', 'ｳ': 'ウ', 'ｴ': 'エ', 'ｵ': 'オ',
    'ｶ': 'カ', 'ｷ': 'キ', 'ｸ': 'ク', 'ｹ': 'ケ', 'ｺ': 'コ',
    'ｻ': 'サ', 'ｼ': 'シ', 'ｽ': 'ス', 'ｾ': 'セ', 'ｿ': 'ソ',
    'ﾀ': 'タ', 'ﾁ': 'チ', 'ﾂ': 'ツ', 'ﾃ': 'テ', 'ﾄ': 'ト',
    'ﾅ': 'ナ', 'ﾆ': 'ニ', 'ﾇ': 'ヌ', 'ﾈ': 'ネ', 'ﾉ': 'ノ',
    'ﾊ': 'ハ', 'ﾋ': 'ヒ', 'ﾌ': 'フ', 'ﾍ': 'ヘ', 'ﾎ': 'ホ',
    'ﾏ': 'マ', 'ﾐ': 'ミ', 'ﾑ': 'ム', 'ﾒ': 'メ', 'ﾓ': 'モ',
    'ﾔ': 'ヤ', 'ﾕ': 'ユ', 'ﾖ': 'ヨ',
    'ﾗ': 'ラ', 'ﾘ': 'リ', 'ﾙ': 'ル', 'ﾚ': 'レ', 'ﾛ': 'ロ',
    'ﾜ': 'ワ', 'ｦ': 'ヲ', 'ﾝ': 'ン',
    'ｧ': 'ァ', 'ｨ': 'ィ', 'ｩ': 'ゥ', 'ｪ': 'ェ', 'ｫ': 'ォ',
    'ｯ': 'ッ', 'ｬ': 'ャ', 'ｭ': 'ュ', 'ｮ': 'ョ',
    '｡': '。', '､': '、', 'ｰ': 'ー', '｢': '「', '｣': '」', '･': '・'
  };
  const reg = new RegExp('(' + Object.keys(kanaMap).join('|') + ')', 'g');
  return str.replace(reg, (match) => kanaMap[match]).replace(/ﾞ/g, '゛').replace(/ﾟ/g, '゜');
};
export const hebonToKana = (str: string) => {
  const hebonKana: Dictionary[] = [{
    ltsu: "ッ", xtsu: "ッ", hwyu: "フュ",
    vya: "ゔャ", vyi: "ゔィ", vyu: "ゔュ", vye: "ゔェ", vyo: "ゔョ",
    kya: "キャ", kyi: "キィ", kyu: "キュ", kye: "キェ", kyo: "キョ",
    kwa: "クァ", kwi: "クィ", kwu: "クゥ", kwe: "クェ", kwo: "クォ",
    gya: "ギャ", gyi: "ギィ", gyu: "ギュ", gye: "ギェ", gyo: "ギョ",
    gwa: "グァ", gwi: "グィ", gwu: "グゥ", gwe: "グェ", gwo: "グォ",
    sya: "シャ", syi: "シィ", syu: "シュ", sye: "シェ", syo: "ショ",
    sha: "シャ", shi: "シ", shu: "シュ", she: "シェ", sho: "ショ",
    jya: "ジャ", jyi: "ジィ", jyu: "ジュ", jye: "ジェ", jyo: "ジョ",
    zya: "ジャ", zyi: "ジィ", zyu: "ジュ", zye: "ジェ", zyo: "ジョ",
    tsa: "ツァ", tsi: "ツィ", tsu: "ツ", tse: "ツェ", tso: "ツォ",
    tya: "チャ", tyi: "チィ", tyu: "チュ", tye: "チェ", tyo: "チョ",
    tha: "テャ", thi: "ティ", thu: "テュ", the: "テェ", tho: "テョ",
    cya: "チャ", cyi: "チィ", cyu: "チュ", cye: "チェ", cyo: "チョ",
    cha: "チャ", chi: "チ", chu: "チュ", che: "チェ", cho: "チョ",
    twa: "トァ", twi: "トィ", twu: "トゥ", twe: "トェ", two: "トォ",
    dya: "ヂャ", dyi: "ヂィ", dyu: "ヂュ", dye: "ヂェ", dyo: "ヂョ",
    dha: "デャ", dhi: "ディ", dhu: "デュ", dhe: "デェ", dho: "デョ",
    nya: "ニャ", nyi: "ニィ", nyu: "ニュ", nye: "ニェ", nyo: "ニョ",
    hya: "ヒャ", hyi: "ヒィ", hyu: "ヒュ", hye: "ヒェ", hyo: "ヒョ",
    hwa: "ファ", hwi: "フィ", hwe: "フェ", hwo: "フォ",
    fya: "フャ", fyu: "フュ", fyo: "フョ", bya: "ビャ",
    byi: "ビィ", byu: "ビュ", bye: "ビェ", byo: "ビョ",
    pya: "ピャ", pyi: "ピィ", pyu: "ピュ", pye: "ピェ", pyo: "ピョ",
    mya: "ミャ", myi: "ミィ", myu: "ミュ", mye: "ミェ", myo: "ミョ",
    rya: "リャ", ryi: "リィ", ryu: "リュ", rye: "リェ", ryo: "リョ",
    wha: "ウァ", whi: "ウィ", whu: "ウ", whe: "ウェ", who: "ウォ",
    ltu: "ッ", xtu: "ッ",
    lya: "ャ", lyi: "ィ", lyu: "ュ", lye: "ェ", lyo: "ョ",
    xya: "ャ", xyi: "ィ", xyu: "ュ", xye: "ェ", xyo: "ョ",
    lwa: "ヮ", xwa: "ヮ",
  }, {
    nn: "ン", mb: "ンb", mm: "ンm", mp: "ンp", 
    bb: "ッb", cc: "ッc", dd: "ッd", ff: "ッf", gg: "ッg", hh: "ッh", jj: "ッj", kk: "ッk",
    ll: "ッl", pp: "ッp", qq: "ッq", rr: "ッr", ss: "ッs", tt: "ッt", vv: "ッv", ww: "ッw",
    xx: "ッx", yy: "ッy", zz: "ッz", 
    ka: "カ", ki: "キ", ku: "ク", ke: "ケ", ko: "コ",
    sa: "サ", si: "シ", su: "ス", se: "セ", so: "ソ",
    ca: "カ", ci: "シ", cu: "ク", ce: "セ", co: "コ",
    ta: "タ", ti: "チ", tu: "ツ", te: "テ", to: "ト",
    na: "ナ", ni: "ニ", nu: "ヌ", ne: "ネ", no: "ノ",
    ha: "ハ", hi: "ヒ", hu: "フ", he: "ヘ", ho: "ホ",
    ma: "マ", mi: "ミ", mu: "ム", me: "メ", mo: "モ",
    ya: "ヤ", yu: "ユ", yo: "ヨ",
    ra: "ラ", ri: "リ", ru: "ル", re: "レ", ro: "ロ",
    wa: "ワ", wi: "ウィ", wu: "ウ", we: "ウェ", wo: "ヲ",
    qa: "クァ", qi: "クィ", qu: "ク", qe: "クェ", qo: "クォ",
    fa: "ファ", fi: "フィ", fu: "フ", fe: "フェ", fo: "フォ",
    va: "ゔァ", vi: "ゔィ", vu: "ゔ", ve: "ゔェ", vo: "ゔォ",
    ga: "ガ", gi: "ギ", gu: "グ", ge: "ゲ", go: "ゴ",
    za: "ザ", zi: "ジ", zu: "ズ", ze: "ゼ", zo: "ゾ",
    ja: "ジャ", ji: "ジ", ju: "ジュ", je: "ジェ", jo: "ジョ",
    da: "ダ", di: "ヂ", du: "ヅ", de: "デ", do: "ド",
    ba: "バ", bi: "ビ", bu: "ブ", be: "ベ", bo: "ボ",
    pa: "パ", pi: "ピ", pu: "プ", pe: "ペ", po: "ポ",
    la: "ァ", li: "ィ", lu: "ゥ", le: "ェ", lo: "ォ",
    xa: "ァ", xi: "ィ", xu: "ゥ", xe: "ェ", xo: "ォ",
  }, {
    a: "ア", i: "イ", u: "ウ", e: "エ", o: "オ",
    n: "ン",
    0: "０", 1: "１", 2: "２", 3: "３", 4: "４", 5: "５",
    6: "６", 7: "７", 8: "８", 9: "９", 
    "-": "ー", ",": "、", "\\.": "。", "\\!": "！", "\\?": "？"
  }];
  const convert = (tables: Dictionary[], text: string) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    tables.reduce((text: any, table: Dictionary) => Object.keys(table).reduce((t, key) => t.replace(new RegExp(key, "gi"), table[key]), text), text)
  );
  return str.split(' ').map((name) => convert(hebonKana, name)).join(' ');
}

export class TextMatch {
  words: { kana: string, eng: string }[];
  constructor(searchWord: string) {
    this.words = searchWord.toLowerCase().split(' ').map((word) => {
      const trimed = word.trim();
      return {
        kana: kanaHalfToFull(hiraToKana(toHalfWidth(hebonToKana(trimed)))),
        eng: trimed
      };
    });
  }
  match = (...fields: (string | null | undefined)[]) => {
    const joined = fields.join(' ');
    const adjusted = {
      kana: kanaHalfToFull(hiraToKana(toHalfWidth(hebonToKana(joined)))),
      eng: joined.toLocaleLowerCase()
    }
    return this.words.some((word) => adjusted.kana.indexOf(word.kana) >= 0 || adjusted.eng.indexOf(word.eng) >= 0);
  }
}